export default __webpack_public_path__ + "static/media/follow-up-visit.d6a4a64b.png";